import React from "react";

import { ICommandParameterModel } from "@formant/core/model/commandTemplate";
import { FormControl, FormItem, FormLabel, Switch } from "@formant/ui-kit";

interface IBooleanParameterProps {
    param: ICommandParameterModel;
    onUpdate: (updates: Partial<ICommandParameterModel>) => void;
}

export const BooleanParameter: React.FC<IBooleanParameterProps> = ({
    param,
    onUpdate,
}) => {
    return (
        <FormItem>
            <FormLabel>Default Value</FormLabel>
            <FormControl>
                <div>
                    <Switch
                        checked={param.value === true}
                        onCheckedChange={value =>
                            onUpdate({ value: value === true })
                        }
                    />
                </div>
            </FormControl>
        </FormItem>
    );
};
